<template>
  <div>
    <div v-if="product.predefined">
      <b-form @submit.prevent="addDates">
        <b-form-group
          id="input-group-1"
          label="Antall deltakere"
          label-for="participants"
          description="Hvis produkten er for 2, del antallet med 2"
        >
          <div slot="label">
            Antall deltakere
            <i
              v-b-tooltip.hover
              title="Oppgi antall personer som kan melde seg på valgt dato."
              class="fa fa-info-circle hoverable"
            ></i>
          </div>
          <b-form-input
            id="participants"
            v-model="form.participants"
            type="number"
            required
            placeholder="10"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Velg start-tid">
          <div slot="label">
            Velg start-tid
            <i
              v-b-tooltip.hover
              title="Velg tidspunkt for når opplevelsen starter."
              class="fa fa-info-circle hoverable"
            ></i>
          </div>
          <timeselector
            v-model="form.starts_at"
            :returnFormat="'HH:mm'"
            :displayFormat="'HH:mm'"
            :padTime="true"
          ></timeselector>
        </b-form-group>
        <b-form-group label="Velg slutt-tid">
          <div slot="label">
            Velg slutt-tid
            <i
              v-b-tooltip.hover
              title="Velg tidspunkt for når opplevelsen slutter."
              class="fa fa-info-circle hoverable"
            ></i>
          </div>
          <timeselector
            v-model="form.ends_at"
            :returnFormat="'HH:mm'"
            :displayFormat="'HH:mm'"
            :padTime="true"
          ></timeselector>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="Bookingfrist"
          label-for="last_bookable"
          description="0 lar kunden booke helt frem til start-tid på oppgitt dato. 1 lar kunde booke inntil 24 timer før start-tid."
        >
          <div slot="label">
            Bookingfrist
            <i
              v-b-tooltip.hover
              title="Oppgi hvor mange dager før start-tid opplevelsen kan bookes."
              class="fa fa-info-circle hoverable"
            ></i>
          </div>
          <b-form-input
            id="last_bookable"
            v-model="form.last_bookable_date"
            type="number"
            required
            placeholder="1"
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2" label="Velg datoer" label-for="date-pick">
          <div slot="label">
            Velg datoer
            <i
              v-b-tooltip.hover
              title="Velg en eller flere datoer som oppgitt informasjon gjelder for."
              class="fa fa-info-circle hoverable"
            ></i>
          </div>
          <date-picker
            locale="nb"
            is-expanded
            :columns="$screens({ default: 1, lg: 2 })"
            id="date-pick"
            v-model="form.dates"
            multiple
            inline
          />
        </b-form-group>
        <b-button type="submit" variant="primary"
          >Legg til {{ form.dates.length > 1 ? 'datoer' : 'dato' }}</b-button
        >
      </b-form>
    </div>
    <div v-else>
      <p>
        {{ product.product_info.name }} er ikke aktivert og det er derfor ikke mulig å legge til ny
        dato for denne opplevelsen. Vennligst kontakt YouWish for å få aktivert bookingsystemet.
      </p>
    </div>
  </div>
</template>

<script>
import Timeselector from '@/components/booking/Timeselector.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/nb';

export default {
  props: ['product'],
  components: {
    Timeselector,
    DatePicker,
  },
  data() {
    const date = new Date();
    const endDate = new Date();

    const startAt = this.product.predefined.starts_at.split(':');
    const endsAt = this.product.predefined.ends_at.split(':');

    date.setHours(startAt[0], startAt[1]);
    endDate.setHours(endsAt[0], endsAt[1]);
    return {
      form: {
        predefined_product_id: this.product.predefined.id,
        dates: [],
        participants: this.product.predefined.participants || 0,
        starts_at: date || null,
        ends_at: endDate || null,
        last_bookable_date: this.product.predefined.last_bookable_date,
      },
    };
  },
  methods: {
    addDates() {
      this.$http.post(`${process.env.VUE_APP_API_URL}/bookings/dates`, this.form).then(res => {
        this.$router.push({ name: 'bookings' });
      });
    },
  },
};
</script>

<style>
</style>
